import React, { useState } from 'react'
import arrowBelow from '../../assets/img/icon/arrow-below.png';
import arrowRight from '../../assets/img/icon/arrow-right.svg';
import { FiHome } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import { SlHome } from "react-icons/sl";

const TakeLookSubHeading = ({ heading }) => {
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const handleMobileNavToggle = () => {
        setIsMobileNavOpen(!isMobileNavOpen);
    };

    const handleMobileNavItemClick = (item) => {
        setIsMobileNavOpen(false);
        // Handle navigation based on item
        navigate(`/${item}`);
    };

    return (
        <>
            {/* Page Header */}
            <div className={`page-header ${isMobileNavOpen ? 'mobile-menu-open' : ''}`}>
                <div className="page-title-section">
                    <div className="title-line"></div>
                    <div className="title-content">
                        <h1 className="page-title">{heading}</h1>
                    </div>
                </div>
                <div className="breadcrumb-navigation">
                    <span className="breadcrumb-item">
                        <SlHome size={16} />
                    </span>
                    <span className="breadcrumb-separator">|</span>
                    <span className="breadcrumb-item">둘러보기</span>
                    <span className="breadcrumb-separator">|</span>
                    <span className="breadcrumb-item active">{heading}</span>
                </div>

                <div className="mobile-navigation-section">
                    <img src={arrowBelow} alt="mobile-nav-icon" onClick={handleMobileNavToggle} className={isMobileNavOpen ? 'active' : ''} />
                </div>

            </div>

            {/* Mobile Navigation */}
            {isMobileNavOpen && (
                <div className="mobile-navigation">

                    <div className="mobile-nav-items">
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('overall-view') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('overall-view')}
                        >
                            <span>전체전경</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('sky-hall') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('sky-hall')}
                        >
                            <span>하늘관</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('hall-vip') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('hall-vip')}
                        >
                            <span>하늘관 VIP</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('starlight-hall') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('starlight-hall')}
                        >
                            <span>별빛관</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('sunshine-hall') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('sunshine-hall')}
                        >
                            <span>햇빛관</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('s-hall') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('s-hall')}
                        >
                            <span>S관</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('a-hall') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('a-hall')}
                        >
                            <span>A관</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('family-hall') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('family-hall')}
                        >
                            <span>가족묘</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('outdoor-hall') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('outdoor-hall')}
                        >
                            <span>야외 봉안당</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                    </div>

                </div>
            )}
        </>
    )
};

export default TakeLookSubHeading;




